var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusEnable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/minus old Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "21-View-order-change-trip-count",
    transform: "translate(-985.000000, -838.000000)",
    fill: "#279CF7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ticket-information",
    transform: "translate(64.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Result-1",
    transform: "translate(68.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/minus-old-Copy",
    transform: "translate(853.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0 C4.70101013,0 0,4.70101013 0,10.5 C0,16.2989899 4.70101013,21 10.5,21 C16.2989899,21 21,16.2989899 21,10.5 C21,7.71522686 19.8937532,5.04451077 17.9246212,3.0753788 C15.9554892,1.10624682 13.2847731,0 10.5,0 Z M17.22,12.117 L3.78,12.117 L3.78,8.883 L17.22,8.883 L17.22,12.117 Z",
    id: "minus"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusEnable);
export default __webpack_public_path__ + "static/media/minus-enable.174160a869822a826960241cac1e5996.svg";
export { ForwardRef as ReactComponent };